import React, { memo, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import { DATE_FORMAT_DEFAULT } from '../../utils/constants'
import { EmptyText } from '../../components/common/CellText'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { TextWrap } from '../../utils/common'
import SkeletonTable from '../../components/Skeleton/SkeletonTable'
import EmptyData from '../../components/image/EmptyData'
import UnreadText from '../../components/common/UnreadText'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Spin } from 'antd'
import { useTheme } from '@mui/material'
import { AiOutlineFieldTime, AiOutlineSearch } from 'react-icons/ai'
import { HiOutlineDocumentText } from 'react-icons/hi2'

const checkUnread = record => record.statusDocIncoming !== 'READ'

function createData(
  document_number,
  incoming_date,
  date_issued,
  title,
  code,
  company_create_name
) {
  return {
    document_number,
    incoming_date,
    date_issued,
    title,
    code,
    company_create_name,
  }
}

const InternalConnectedDocumentIncoming = props => {
  const { internalConnectedDocumentStore, advFilter } = props
  const {
    internalConnectedDocumentIncomingList,
    internalConnectedDocumentInTotal,
  } = internalConnectedDocumentStore
  const [
    internalConnectedDocumentIncomingPageList,
    setInternalConnectedDocumentIncomingPageList,
  ] = useState([])
  // console.log('check', internalConnectedDocumentIncomingPageList)
  const location = useLocation()
  const navigate = useNavigate()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [filter, setFilter] = useState(advFilter)
  useEffect(() => {
    setFilter(advFilter)
  }, [advFilter])

  const [loading, setLoading] = useState(true)
  const theme = useTheme()
  const [rows, setRows] = useState([])
  useEffect(() => {
    const param = {
      page: queryStringParse.page || filter.page,
      size: queryStringParse.size || filter.size,
      keyword: queryStringParse.keyword || filter.keyword,
      fromDateIssue: queryStringParse.fromDateIssue || filter.fromDateIssue,
      toDateIssue: queryStringParse.toDateIssue || filter.toDateIssue,
    }

    setFilter(param)
    ;(async () => {
      setLoading(true)
      internalConnectedDocumentStore.clear()
      await internalConnectedDocumentStore
        .getInternalConnectedDocumentIncomingList(param)
        .then(response => {
          setInternalConnectedDocumentIncomingPageList(response.data)
        })
      setIsRefreshPage(false)
      setLoading(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isRefreshPage) return
    ;(async () => {
      try {
        setLoading(true)
        internalConnectedDocumentStore.clear()
        const response =
          await internalConnectedDocumentStore.getInternalConnectedDocumentIncomingList(
            filter
          )

        setInternalConnectedDocumentIncomingPageList(response.data)
        setLoading(false)
      } catch (err) {
        console.log(err)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  const [hasMore, setHasMore] = useState(false)
  const fetchMoreData = async () => {
    if (
      internalConnectedDocumentIncomingList.length >=
      internalConnectedDocumentIncomingPageList.totalElements
    ) {
      setHasMore(false)
      return
    }
    internalConnectedDocumentStore.setQueryParamsInDoc({
      page: internalConnectedDocumentStore.defaultQueryParamsInDoc.page + 1,
      size: 10,
    })
    try {
      await internalConnectedDocumentStore.getInternalConnectedDocumentIncomingList(
        {
          ...filter,
          page: internalConnectedDocumentStore.defaultQueryParamsInDoc.page,
          size: 10,
        }
      )
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (
      internalConnectedDocumentIncomingList.length <
      internalConnectedDocumentIncomingPageList.totalElements
    ) {
      setHasMore(true)
      return
    }
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleQuickSearch = async event => {
    internalConnectedDocumentStore.clear()
    event.preventDefault()
    try {
      await internalConnectedDocumentStore.getInternalConnectedDocumentIncomingList(
        filter
      )
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    setRows(
      internalConnectedDocumentIncomingList.map(record =>
        createData(
          <UnreadText
            text={
              <div className="flex gap-2 w-[100%] items-center">
                <HiOutlineDocumentText size={20} color={theme.color.primary} />
                <div
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                    color: theme.color.primary,
                  }}>
                  {record.documentNumber}
                </div>
              </div>
            }
            isUnread={checkUnread(record)}
            width={'100%'}
          />,
          <UnreadText
            text={
              <div
                style={{
                  fontSize: 13,
                  color: theme.color.gray,
                }}>
                Ngày đến:{' '}
                {moment(record.incomingDate).format(DATE_FORMAT_DEFAULT)}
              </div>
            }
            isUnread={checkUnread(record)}
            width={'100%'}
          />,
          record.dateIssue ? (
            <UnreadText
              text={
                <div>
                  Ngày ban hành:{' '}
                  {moment(record.dateIssue).format(DATE_FORMAT_DEFAULT)}
                </div>
              }
              isUnread={checkUnread(record)}
              width={'100%'}
            />
          ) : (
            <TextWrap style={{ fontSize: 12 }}>
              <EmptyText>-----------------</EmptyText>
            </TextWrap>
          ),
          <UnreadText
            text={
              <div
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%',
                  lineHeight: '25px',
                  WebkitLineClamp: '2',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  maxHeight: '50px',
                }}>
                {record.title}
              </div>
            }
            isUnread={checkUnread(record)}
            width={'100%'}
          />,
          record.code,
          <UnreadText
            text={
              <div className="flex gap-2 w-[100%] items-center">
                <div
                  style={{
                    whiteSpace: 'pre-line',
                    wordBreak: 'break-word',
                    fontSize: 15,
                  }}>
                  {record.companyCreateName}
                </div>
              </div>
            }
            isUnread={checkUnread(record)}
            width={'100%'}
          />
        )
      )
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalConnectedDocumentIncomingList])

  return (
    <>
      <form onSubmit={e => handleQuickSearch(e)}>
        <div
          className="mt-2 px-5 py-3 rounded-xl w-full  focus-visible:outline-none"
          style={{
            display: 'flex',
            alignItems: 'center',
            background: theme.background.light,
          }}>
          <AiOutlineSearch color="#65696e" fontSize={25} />
          <input
            type="text"
            placeholder="Tìm kiếm"
            className="py-1 rounded-xl w-full  focus-visible:outline-none"
            style={{ background: theme.background.light }}
            onChange={e => {
              internalConnectedDocumentStore.clear()
              setFilter({
                ...filter,
                page: 0,
                size: 10,
                keyword: e.target.value.trim(),
              })
            }}
            onBlur={e => handleQuickSearch(e)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                handleQuickSearch(e)
              }
            }}
          />
        </div>
      </form>
      {loading ? (
        <SkeletonTable />
      ) : internalConnectedDocumentIncomingList?.length > 0 ? (
        <section className="mt-1 overflow-x-auto hideScrollbar pb-[30px]">
          <InfiniteScroll
            dataLength={internalConnectedDocumentIncomingList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            style={{
              scrollSnapStop: 'always',
            }}
            scrollableTarget="infinityScrollableDiv"
            loader={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                }}>
                {internalConnectedDocumentIncomingList.length > 10 ? (
                  <Spin tip="Đang tải..." />
                ) : (
                  ''
                )}
              </div>
            }>
            <div className="inline-block w-[100%] overflow-visible hideScrollbar ">
              <div>
                {rows.map((row, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      navigate(
                        `/internal-connected-document/incoming-document/view/${row.code}`
                      )
                    }}
                    style={{
                      backgroundColor: '#ffffff',
                      padding: '12px 8px 8px 8px',
                      margin: ' 15px auto',
                      borderRadius: '10px',
                      boxShadow:
                        'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
                    }}>
                    <div className="flex justify-between items-center">
                      <div
                        className="pt-1"
                        style={{ width: 'calc(100% - 155px)' }}>
                        {row.document_number}
                      </div>
                      <div className="flex items-center" style={{ width: 155 }}>
                        <div style={{ paddingRight: 3 }}>
                          <AiOutlineFieldTime
                            size={16}
                            color={theme.color.gray}
                          />
                        </div>
                        {row.incoming_date}
                      </div>
                    </div>
                    <div className="mt-2 ">{row.title}</div>
                    <div>{row.date_issued}</div>
                    <div className="mt-2 ">{row.company_create_name}</div>
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        </section>
      ) : (
        <EmptyData />
      )}
    </>
  )
}

export default memo(
  inject('internalConnectedDocumentStore')(
    observer(InternalConnectedDocumentIncoming)
  )
)
